import React, { useEffect } from "react";
import "./reusablemodal.scss";

const ReusableModal = ({
  children,
  closable = true,
  handleSave = () => {},
  handleCancel = () => {},
  customClass,
  width = "20%",
  closeIcon
}) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    const handleOutsideClick = (e) => {
      const modalElement = document.querySelector(".modalContainer");
      if (modalElement && !modalElement.contains(e.target)) {
        handleCancel();
      }
    };

    if (closable) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.body.style.overflow = "auto";
      if (closable) {
        document.removeEventListener("mousedown", handleOutsideClick);
      }
    };
  }, [closable, handleCancel]);

  return <div className="modalcontainers">{children}</div>;
};

export default ReusableModal;
